"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Download = void 0;
const fs_1 = __importDefault(require("fs"));
const url_search_params_1 = __importDefault(require("@ungap/url-search-params"));
const APIErrors_1 = require("./resources/APIErrors");
const APITasks_1 = require("./resources/APITasks");
const APIAbortController_1 = require("./APIAbortController");
const FSIServerClientUtils_1 = require("./FSIServerClientUtils");
const TaskProgress_1 = require("./TaskProgress");
const index_1 = require("./index");
const LogLevel_1 = require("./LogLevel");
const URLSearchParams = url_search_params_1.default;
const modeNode = FSIServerClientUtils_1.FSIServerClientUtils.GET_MODE_NODE();
class Download {
    constructor(classInit, taskController) {
        this.classInit = classInit;
        this.taskController = taskController;
        this.client = classInit.client;
        this.com = classInit.com;
        this.baseURL = this.client.getServerBaseQuery();
    }
    save(pathOrEntry, targetPathArg, options = {}) {
        let targetPath = (typeof (targetPathArg) !== "string") ? "" : targetPathArg;
        const self = this;
        const taskDef = (modeNode) ? APITasks_1.APITasks.downloadFile : APITasks_1.APITasks.preparingFile;
        const downloadAbortController = this.com.getNewAbortController();
        let streamTempName = "";
        let streamFinalName = "";
        let success = true;
        const setSubTaskTemporary = () => {
            if (options._taskProgress) {
                options._taskProgress.temporary = true;
            }
        };
        const path = (typeof (pathOrEntry) === "string") ? pathOrEntry : pathOrEntry.path;
        if (options.fnProgress !== undefined || options._fnQueueProgress !== undefined) {
            options._taskProgress = new TaskProgress_1.TaskProgress();
            options._taskProgress.currentTask = this.com.taskSupplier.get(APITasks_1.APITasks.downloadFile, [path]);
        }
        targetPath = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(targetPath);
        let logPath = path;
        if (options.getICCProfile) {
            logPath += ".icc";
        }
        const onProgress = (loaded, total) => {
            self.taskController.onStepProgress(-1, options, APITasks_1.APITasks.downloadFile, [logPath], loaded, total);
            if (options._taskProgress) {
                options._taskProgress.bytesTotal = total;
                options._taskProgress.bytesDone = loaded;
            }
            if (options._taskProgress && options.fnProgress) {
                options.fnProgress.fn.call(options.fnProgress.ctx, options._taskProgress);
            }
        };
        this.taskController.setCurrentTask(0, taskDef, [logPath]);
        APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
        if (!modeNode || options.archiveType) {
            return this.addFileToDownload(path, options);
        }
        let stream;
        const mainPromise = new Promise((resolve, reject) => {
            APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
            const rejectWithError = (err, cnt = [], errDef = APIErrors_1.APIErrors.anyError) => {
                if (err) {
                    return reject(err);
                }
                else {
                    return reject(self.com.err.get(APIErrors_1.APIErrors.downloadFile, [path], errDef, cnt));
                }
            };
            const pf = FSIServerClientUtils_1.FSIServerClientUtils.FILE_AND_PATH(path);
            if (pf.error !== undefined) {
                rejectWithError(null, [pf.errorContent], pf.error);
            }
            if (options.fileName) {
                pf.dir = options.fileName;
            }
            let mkDirPromise;
            if (!options.flattenTargetPath) {
                targetPath = FSIServerClientUtils_1.FSIServerClientUtils.JOIN_PATH(targetPath, pf.path);
                mkDirPromise = new Promise((resolveMkDir, rejectMkDir) => {
                    try {
                        fs_1.default.mkdirSync(targetPath, { recursive: true });
                        resolveMkDir();
                    }
                    catch (err) {
                        rejectMkDir(err);
                    }
                });
            }
            else {
                mkDirPromise = new Promise((resolveMkDir) => {
                    return resolveMkDir();
                });
            }
            targetPath = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(targetPath);
            const createStream = async (headers) => {
                if (options.getICCProfile === true) {
                    pf.dir += ".icc";
                }
                else if ((options.renderingQuery || options.renderOptions !== undefined)
                    && typeof (headers["content-type"]) === "string") {
                    const val = headers["content-type"];
                    let ext = false;
                    if (val) {
                        ext = self.com.lookupMimeExtension(val);
                    }
                    if (ext && ext.length > 0) {
                        if (!options.replaceFileExtension) {
                            pf.dir += "." + ext;
                        }
                        else {
                            pf.dir = FSIServerClientUtils_1.FSIServerClientUtils.REPLACE_FILE_EXTENSION(pf.dir, ext);
                        }
                    }
                }
                let reply = "";
                streamFinalName = targetPath + pf.dir;
                streamTempName = targetPath + pf.dir + ".tmp";
                const getFileAccess = (thePath) => {
                    const ret = {
                        err: undefined,
                        exists: true,
                        writeable: false
                    };
                    try {
                        fs_1.default.accessSync(thePath, fs_1.default.constants.W_OK);
                        ret.writeable = true;
                    }
                    catch (err) {
                        if (err.code !== 'ENOENT') {
                            ret.exists = true;
                            ret.err = err;
                        }
                        else {
                            ret.writeable = true;
                            ret.exists = false;
                        }
                    }
                    if (ret.writeable && ret.exists) {
                        try {
                            const stat = fs_1.default.statSync(thePath);
                            if (stat.isDirectory()) {
                                ret.writeable = false;
                                ret.err = self.com.err.get(APIErrors_1.APIErrors.downloadFile, [path], APIErrors_1.APIErrors.isDirectory, [thePath]);
                            }
                        }
                        catch (err) {
                            ret.err = err;
                        }
                    }
                    return ret;
                };
                const accessFinal = getFileAccess(streamFinalName);
                if (!accessFinal.writeable) {
                    return reject(accessFinal.err);
                }
                const accessTemp = getFileAccess(streamTempName);
                if (!accessTemp.writeable) {
                    return reject(accessFinal.err);
                }
                if (accessFinal.exists && !options.overwriteExisting) {
                    if (options.fnPrompt) {
                        const res = await self.com.getOverwriteReply(options, targetPath + pf.dir, this.taskController);
                        reply = res.reply;
                    }
                    if (!reply || reply === "skip") {
                        setSubTaskTemporary();
                        self.callProgress(LogLevel_1.LogLevel.trace, options, APITasks_1.APITasks.skipDownload, [targetPath + pf.dir]);
                        downloadAbortController.abort();
                        return resolve(false);
                    }
                    else if (reply === "cancel") {
                        return reject(self.com.err.get(APIErrors_1.APIErrors.userAborted));
                    }
                }
                try {
                    stream = fs_1.default.createWriteStream(streamTempName);
                }
                catch (err) {
                    return reject(err);
                }
                stream.on("close", () => {
                    if (success) {
                        const lmDate = headers["last-modified"] || null;
                        if (lmDate) {
                            const lm = Math.floor(new Date(lmDate).getTime());
                            if (!isNaN(lm)) {
                                fs_1.default.utimesSync(streamTempName, new Date(), new Date(lmDate));
                            }
                        }
                        fs_1.default.rename(streamTempName, streamFinalName, (err) => {
                            if (err) {
                                return reject(err);
                            }
                            else {
                                return resolve(true);
                            }
                        });
                    }
                    else {
                        fs_1.default.unlink(streamTempName, (err) => {
                            if (err) {
                                self.taskController.errorNative(err);
                            }
                        });
                    }
                });
                stream.on("error", (err) => {
                    stream.close();
                    return reject(err);
                });
            };
            mkDirPromise.then(() => {
                APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
                const url = self.getDownloadURL(path, options);
                const config = this.com.getAxiosRequestConfig({ abortController: downloadAbortController }, { Accept: "*/*" });
                config.responseType = "stream";
                this.com.getResponse(url, undefined, config)
                    .then(async (response) => {
                    APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
                    if (options._taskProgress) {
                        options._taskProgress.bytesTotal = parseInt(response.headers["content-length"] || "0", 10);
                        options._taskProgress.bytesDone = 0;
                    }
                    await createStream(response.headers);
                    if (stream) {
                        response.data.pipe(stream);
                        let timeLast = FSIServerClientUtils_1.FSIServerClientUtils.NOW();
                        const totalSize = parseInt(response.headers['content-length'] || "0");
                        let downloaded = 0;
                        response.data.on('data', (chunk) => {
                            downloaded += chunk.byteLength;
                            const now = FSIServerClientUtils_1.FSIServerClientUtils.NOW();
                            if (now - timeLast > 500) {
                                timeLast = now;
                                onProgress(downloaded, totalSize);
                            }
                            if (APIAbortController_1.APIAbortController.IS_ABORTED(options.abortController)) {
                                rejectWithError(self.com.err.get(APIErrors_1.APIErrors.userAborted));
                            }
                        });
                        response.data.on('end', () => {
                            onProgress(downloaded, totalSize);
                        });
                        response.data.on('error', (err) => {
                            stream.close();
                            return rejectWithError(err);
                        });
                    }
                })
                    .catch(err => {
                    return rejectWithError(err);
                });
            })
                .catch(err => {
                return rejectWithError(err);
            });
        });
        return new Promise((resolveMain, rejectMain) => {
            mainPromise
                .then(resolveMain)
                .catch((err) => {
                success = false;
                downloadAbortController.abort();
                rejectMain(err);
            });
        });
    }
    createAndDownloadArchive(options) {
        const self = this;
        return new Promise((resolve, reject) => {
            self.createDownloadArchive(options, true)
                .then((downloadID) => {
                if (!downloadID) {
                    return resolve("");
                }
                else {
                    self.downloadArchive(options, downloadID)
                        .then(() => {
                        if (downloadID === "file") {
                            resolve(downloadID);
                        }
                        else {
                            self.client.delete("_downloads/" + index_1.FSIServerClient.ENCODE_PATH(downloadID), "file")
                                .then(() => {
                                resolve(downloadID);
                            })
                                .catch(reject);
                        }
                    })
                        .catch(reject);
                }
            })
                .catch(reject);
        });
    }
    createDownloadArchive(options, waitForCompletion) {
        const self = this;
        return new Promise((resolve, reject) => {
            if (!options._downloadFiles || options._downloadFiles.length < 1) {
                return resolve("");
            }
            const files = options._downloadFiles;
            let archiveName;
            let archiveFileName;
            let watchQuery;
            let listURL;
            let downloadID;
            let entryCountChecked = 0;
            const setSubTaskTemporary = () => {
                if (options._taskProgress) {
                    options._taskProgress.temporary = true;
                }
            };
            const waitForArchive = () => {
                if (downloadID === undefined) {
                    setSubTaskTemporary();
                    self.callProgress(LogLevel_1.LogLevel.trace, options, APITasks_1.APITasks.waitDownload, [archiveFileName], 0, 100);
                    this.com.getJSON(listURL, undefined)
                        .then(body => {
                        if (body) {
                            const ld = body;
                            if (ld.summary.entryCount > 0 && ld.summary.entryCount !== entryCountChecked) {
                                ld.entries.pop();
                                entryCountChecked = ld.summary.entryCount;
                                for (const ldEntry of ld.entries) {
                                    const entry = ldEntry;
                                    if (entry.fileName === archiveFileName && entry.src) {
                                        downloadID = entry.src;
                                        watchQuery.set("items", downloadID);
                                        return waitForArchive();
                                    }
                                }
                            }
                        }
                        setTimeout(waitForArchive, 500);
                    })
                        .catch(reject);
                }
                else {
                    if (!waitForCompletion) {
                        return resolve(downloadID);
                    }
                    this.com.postJSON("server", watchQuery, undefined, undefined, options)
                        .then(body => {
                        const ld = body;
                        if (ld.entries.length > 0) {
                            const entry = ld.entries[0];
                            if (entry.src === downloadID) {
                                let progress = parseFloat(entry.progress);
                                if (isNaN(progress)) {
                                    progress = 0;
                                }
                                setSubTaskTemporary();
                                self.callProgress(LogLevel_1.LogLevel.trace, options, APITasks_1.APITasks.waitDownload, [archiveFileName], progress, 100);
                                if (entry.status === "1" && entry.progress === "100") {
                                    return resolve(downloadID);
                                }
                            }
                        }
                        setTimeout(waitForArchive, 250);
                    })
                        .catch(reject);
                }
            };
            if (files.length === 1 && !options.archiveType) {
                resolve("file");
            }
            else {
                const ql = new URLSearchParams();
                ql.set("source", "_downloads");
                ql.set("type", "list");
                ql.set("tpl", "interface_thumbview_downloads.json");
                ql.set("sort", "CREATIONDATE");
                ql.set("sortorder", "desc");
                ql.set("headers", "webinterface");
                listURL = this.client.getServerBaseQueryPath() + ql.toString();
                archiveName = options.archiveName || "API_" + Math.round(1000000 * Math.random()) + "_" + FSIServerClientUtils_1.FSIServerClientUtils.NOW();
                archiveFileName = archiveName + "." + options.archiveType;
                watchQuery = new URLSearchParams();
                watchQuery.set("type", "list");
                watchQuery.set("tpl", "interface_thumbview_downloads.json");
                watchQuery.set("source", "_downloads");
                watchQuery.set("headers", "webinterface");
                const q = new URLSearchParams();
                q.set("cmd", "createAndStart");
                q.set("name", archiveName);
                q.set("appendFileExtension", options.replaceFileExtension ? "false" : "true");
                q.set("archiveType", options.archiveType);
                if (options.scheduleDate) {
                    q.set("scheduleDate", options.scheduleDate.toString());
                }
                let renderingQuery = "";
                if (options.renderingQuery) {
                    renderingQuery = options.renderingQuery;
                }
                else if (options.renderOptions) {
                    const qe = new URLSearchParams();
                    qe.set("type", "image");
                    const map = options.renderOptions;
                    for (const key of Object.keys(map)) {
                        qe.append(key, map[key]);
                    }
                    renderingQuery = qe.toString();
                }
                if (renderingQuery && renderingQuery.length > 0) {
                    q.set("renderingQuery", renderingQuery);
                }
                for (const file of files) {
                    q.append("file", file);
                }
                return this.com.postJSON(self.client.getServicePath("jobqueue"), q, undefined, undefined, options)
                    .then(body => {
                    if (!body || !body.statuscode || body.statuscode !== 200) {
                        return reject(self._com.err.get(APIErrors_1.APIErrors.invalidServerReply));
                    }
                    if (body.id) {
                        downloadID = "" + body.id;
                        watchQuery.set("items", downloadID);
                    }
                    if (waitForCompletion) {
                        setSubTaskTemporary();
                        self.callProgress(LogLevel_1.LogLevel.trace, options, APITasks_1.APITasks.waitDownload, [archiveFileName], 0, 100);
                    }
                    waitForArchive();
                })
                    .catch(reject);
            }
        });
    }
    callProgress(level, options, apiTaskDef, content, pos = 0, length = 0) {
        this.taskController.onStepProgress(level, options, apiTaskDef, content, pos, length);
    }
    getDownloadURL(path, options, forSaving = false) {
        let url;
        if (options.getICCProfile === true) {
            url = this.client.getServicePath("icc") + "/" + index_1.FSIServerClient.ENCODE_PATH(path);
        }
        else {
            let renderingQuery = "";
            if (options.renderingQuery) {
                renderingQuery = options.renderingQuery;
                if (forSaving) {
                    renderingQuery += "&save=1";
                }
            }
            else if (options.renderOptions) {
                const q = new URLSearchParams();
                const map = options.renderOptions;
                for (const key of Object.keys(map)) {
                    q.append(key, map[key]);
                }
                q.set("type", "image");
                q.set("source", path);
                if (forSaving) {
                    q.set("save", "1");
                }
                renderingQuery = q.toString();
            }
            if (!renderingQuery) {
                url = this.client.getServicePath("file") + "/" + index_1.FSIServerClient.ENCODE_PATH(path);
            }
            else {
                url = this.client.getServerBaseQueryPath() + renderingQuery;
            }
        }
        if (forSaving) {
            url = this.client.getHost() + url;
        }
        return url;
    }
    addFileToDownload(path, options = {}) {
        const self = this;
        return new Promise((resolve, reject) => {
            if (!options._downloadFiles) {
                options._downloadFiles = [];
            }
            options._downloadFiles.push(path);
            if (!modeNode && !options.queued) {
                self.downloadArchive(options)
                    .then(() => {
                    resolve(true);
                })
                    .catch((err) => {
                    reject(err);
                });
            }
            else
                resolve(true);
        });
    }
    downloadArchive(options, downloadID = "") {
        const self = this;
        return new Promise((resolve, reject) => {
            if (!options._downloadFiles || options._downloadFiles.length < 1) {
                delete options._downloadFiles;
                return resolve(true);
            }
            const files = options._downloadFiles;
            delete options._downloadFiles;
            const downloadURL = (url) => {
                let openedWindow;
                if (window) {
                    openedWindow = window.open(url, "_blank");
                    if (!openedWindow) {
                        reject(new Error("failed to open download window. Popup forbidden?"));
                    }
                    const intervalClose = setInterval(() => {
                        if (openedWindow && openedWindow.closed) {
                            clearInterval(intervalClose);
                            return resolve(true);
                        }
                    }, 100);
                }
            };
            if (files.length === 1) {
                downloadURL(self.getDownloadURL(files[0], options, true));
            }
            else if (downloadID) {
                let url = self.client.getService("file");
                url += "/_downloads/" + downloadID;
                downloadURL(url);
            }
        });
    }
}
exports.Download = Download;
